import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteViewDocument } from './delete.generated';

export const useDeleteView = (options: ApiOptions<typeof DeleteViewDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(DeleteViewDocument, {
    ...useNotifications(DeleteViewDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.views.delete_success'),
    }),

    ...options,
  });
};
